import { CalendarEvent, CalendarEventAction } from 'angular-calendar';
import { startOfDay } from 'date-fns';

export class SkillztankCalendarEvent implements CalendarEvent {
  _id?: string;
  start: Date;
  end?: Date;
  startTime: any;
  endTime: any;
  title: string;
  contentID?: any;
  courseID?: any;
  sectionID?: any;
  lectureID?: any;
  noteID?: any;
  users?: any;
  blogID?: any;
  color?: {
    primary: string;
    secondary: string;
  };
  actions?: CalendarEventAction[];
  allDay?: boolean;
  cssClass?: string;
  resizable?: {
    beforeStart?: boolean;
    afterEnd?: boolean;
  };
  draggable?: boolean;
  meta?: {
    location: string;
    notes: string;
  };

  constructor(data?) {
    data = data || {};
    this.start = new Date(data.start) || startOfDay(new Date());
    this.noteID = data.noteID;
    this.end = data.end ? new Date(data.end) : null;
    this.startTime = data.startTime || null;
    this.endTime = data.endTime || null;
    this._id = data._id || '';
    this.title = data.title || '';
    this.contentID = data.contentID || null;
    this.courseID = data.courseID || null;
    this.sectionID = data.sectionID || null;
    this.lectureID = data.lectureID || null;
    this.users = data.users || null;
    this.blogID = data.blogID || null;
    this.color = {
      primary: (data.color && data.color.primary) || '#247ba0',
      secondary: (data.color && data.color.secondary) || '#D1E8FF',
    };
    this.draggable = data.draggable || true;
    this.resizable = {
      beforeStart: (data.resizable && data.resizable.beforeStart) || true,
      afterEnd: (data.resizable && data.resizable.afterEnd) || true,
    };
    this.actions = data.actions || [];
    this.allDay = data.allDay || false;
    this.cssClass = data.cssClass || '';
    this.meta = {
      location: data.location || (data.meta && data.meta.location) || '',
      notes: data.notes || (data.meta && data.meta.notes) || '',
    };
  }
}
